import React, { useState, useEffect } from "react";
import { connect } from "react-redux";
import { get } from "lodash";
import { reduxForm, Field, reset } from "redux-form";
import { NotificationManager } from "react-notifications";

import { FormField } from "../../../sharedComponents/formField";
import { createCategory, updateCategory } from "../../../store/actions";

const AddCategoryForm = ({ initialValues, onSuccess, onCancel, handleSubmit, createCategory, updateCategory, resetForm }) => {
    const [editing, setEditing] = useState(false);

    useEffect(() => {
        setEditing(initialValues && initialValues.id ? true : false);
    }, [initialValues]);

    const validateForm = (values) => {
        const successHandler = (event) => {
            event.json().then(data => {
                resetForm('AddCategoryForm');
                onSuccess && onSuccess({ panel: 1, data });
                NotificationManager.success(editing ? "Item has been updated!" : "Item has been added!", "", 5000);
            })
        }
        editing ? updateCategory({ id: initialValues.id, ...values }, successHandler) : createCategory({ group: initialValues.group, ...values }, successHandler);
    }

    return <form onSubmit={handleSubmit(validateForm)}>
        <div className="card card-default p-3">
            <h4>{editing ? "Update" : "Add"} Category</h4>
            <div className="row">
                <Field
                    name="name"
                    formGroupClass="col-12"
                    type="text"
                    component={FormField}
                    label="Category"
                />
            </div>
            <div className="row">
                <Field
                    name="seq"
                    formGroupClass="col-6"
                    type="number"
                    component={FormField}
                    label="Seq"
                />
            </div>
            <div className="text-right">
                <button type="button" className="btn mr-1" onClick={() => onCancel(1)}>
                    <span className="text-primary-dark">Cancel</span>
                </button>
                <button type="submit" className="btn btn-primary-dark">{editing ? "Update" : "Add"}</button>
            </div>
        </div>
    </form>
}

const mapStateToProps = (state) => {
    return {
        categoryGroupList: get(state, "AddRecipe.categoryGroupList.results", [])
    };
};

const mapDispatchToProps = {
    resetForm: reset,
    createCategory,
    updateCategory
};

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(
    reduxForm({
        form: "AddCategoryForm",
        enableReinitialize: true
    })(AddCategoryForm)
);
